import { Children, cloneElement, useRef } from 'react';
import Tab from 'components/Tab';
import { useHashTab } from 'utils/hooks';

/**
 * Declares a tab. The name reaches the URL hash, so it is not always the
 * table's own title.
 */
export const EntityTab = ({ children }) => children;

/**
 * The page's tab strip, taking its tabs as children so a conditional one is
 * written where it belongs:
 *
 *     <EntityTabs>
 *         <EntityTab name="Related Categories">...</EntityTab>
 *         {hasFlavors && <EntityTab name="Flavors">...</EntityTab>}
 *     </EntityTabs>
 */
const EntityTabs = ({ children }) => {
    const tabGroupRef = useRef();
    const declared = Children.toArray(children).filter(
        (child) => child && child.props,
    );
    const names = declared.map(({ props }) => props.name);
    const { selectedIndex, onChange } = useHashTab(names, tabGroupRef);

    return (
        <div ref={tabGroupRef}>
            <Tab.Group selectedIndex={selectedIndex} onChange={onChange}>
                <Tab.List tabNames={names} />
                {/* An array, never a fragment: `Children.map` counts a
                  fragment as one child and collapses every panel into the
                  first tab. */}
                <Tab.Panels>
                    {declared.map(({ props }, idx) =>
                        cloneElement(props.children, { key: names[idx] }),
                    )}
                </Tab.Panels>
            </Tab.Group>
        </div>
    );
};

export default EntityTabs;
